// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/referrals.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/referrals.proto.
 */
export const file_cortado_v1_referrals: GenFile = /*@__PURE__*/
  fileDesc("Chpjb3J0YWRvL3YxL3JlZmVycmFscy5wcm90bxIKY29ydGFkby52MSJOChRMZWFkUmVmZXJyYWxTZXR0aW5ncxIXCg9vcmdhbml6YXRpb25faWQYASABKAkSDwoHZW5hYmxlZBgCIAEoCBIMCgRjb2RlGAMgASgJIq8BChNMZWFkUmVmZXJyYWxQYXJ0bmVyEgoKAmlkGAEgASgJEhcKD29yZ2FuaXphdGlvbl9pZBgCIAEoCRINCgVsYWJlbBgUIAEoCRIhChlwYXJ0bmVyX29yZ2FuaXphdGlvbl9uYW1lGBUgASgJEhEKCXJlYWNoYWJsZRgyIAEoCBIuCgpjcmVhdGVkX2F0GDwgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCL4AgoMTGVhZFJlZmVycmFsEgoKAmlkGAEgASgJEhcKD29yZ2FuaXphdGlvbl9pZBgCIAEoCRISCgppbnF1aXJ5X2lkGAogASgJEiMKG3JlY2lwaWVudF9vcmdhbml6YXRpb25fbmFtZRgUIAEoCRIRCgRub3RlGBUgASgJSACIAQESMgoGc3RhdHVzGDIgASgOMiIuY29ydGFkby52MS5MZWFkUmVmZXJyYWxTdGF0dXNFbnVtEi4KCmV4cGlyZXNfYXQYMyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEjUKDHJlc3BvbmRlZF9hdBg0IAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIAYgBARIuCgpjcmVhdGVkX2F0GDwgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBISCgpjcmVhdGVkX2J5GD0gASgJQgcKBV9ub3RlQg8KDV9yZXNwb25kZWRfYXQisQMKFEluY29taW5nTGVhZFJlZmVycmFsEgoKAmlkGAEgASgJEiAKGHNlbmRlcl9vcmdhbml6YXRpb25fbmFtZRgUIAEoCRIdChBldmVudF90eXBlX2xhYmVsGBUgASgJSACIAQESOQoQZmlyc3RfZXZlbnRfZGF0ZRgWIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIAYgBARIhChRmaXJzdF9ldmVudF90aW1lem9uZRgXIAEoCUgCiAEBEhkKEXRvdGFsX2d1ZXN0X2NvdW50GBggASgFEhQKDGV2ZW50c19jb3VudBgZIAEoBRIRCgRub3RlGBogASgJSAOIAQESLgoKZXhwaXJlc19hdBgzIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLgoKY3JlYXRlZF9hdBg8IAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBCEwoRX2V2ZW50X3R5cGVfbGFiZWxCEwoRX2ZpcnN0X2V2ZW50X2RhdGVCFwoVX2ZpcnN0X2V2ZW50X3RpbWV6b25lQgcKBV9ub3RlIjkKHkdldExlYWRSZWZlcnJhbFNldHRpbmdzUmVxdWVzdBIXCg9vcmdhbml6YXRpb25faWQYASABKAkiVQofR2V0TGVhZFJlZmVycmFsU2V0dGluZ3NSZXNwb25zZRIyCghzZXR0aW5ncxgBIAEoCzIgLmNvcnRhZG8udjEuTGVhZFJlZmVycmFsU2V0dGluZ3MiTQohVXBkYXRlTGVhZFJlZmVycmFsU2V0dGluZ3NSZXF1ZXN0EhcKD29yZ2FuaXphdGlvbl9pZBgBIAEoCRIPCgdlbmFibGVkGAIgASgIIlgKIlVwZGF0ZUxlYWRSZWZlcnJhbFNldHRpbmdzUmVzcG9uc2USMgoIc2V0dGluZ3MYASABKAsyIC5jb3J0YWRvLnYxLkxlYWRSZWZlcnJhbFNldHRpbmdzIjwKIVJlZ2VuZXJhdGVMZWFkUmVmZXJyYWxDb2RlUmVxdWVzdBIXCg9vcmdhbml6YXRpb25faWQYASABKAkiWAoiUmVnZW5lcmF0ZUxlYWRSZWZlcnJhbENvZGVSZXNwb25zZRIyCghzZXR0aW5ncxgBIAEoCzIgLmNvcnRhZG8udjEuTGVhZFJlZmVycmFsU2V0dGluZ3MiRgodTG9va3VwTGVhZFJlZmVycmFsQ29kZVJlcXVlc3QSFwoPb3JnYW5pemF0aW9uX2lkGAEgASgJEgwKBGNvZGUYAiABKAkiOwoeTG9va3VwTGVhZFJlZmVycmFsQ29kZVJlc3BvbnNlEhkKEW9yZ2FuaXphdGlvbl9uYW1lGAEgASgJIjoKH0xpc3RMZWFkUmVmZXJyYWxQYXJ0bmVyc1JlcXVlc3QSFwoPb3JnYW5pemF0aW9uX2lkGAEgASgJIlUKIExpc3RMZWFkUmVmZXJyYWxQYXJ0bmVyc1Jlc3BvbnNlEjEKCHBhcnRuZXJzGAEgAygLMh8uY29ydGFkby52MS5MZWFkUmVmZXJyYWxQYXJ0bmVyImcKIENyZWF0ZUxlYWRSZWZlcnJhbFBhcnRuZXJSZXF1ZXN0EhcKD29yZ2FuaXphdGlvbl9pZBgBIAEoCRIMCgRjb2RlGAIgASgJEhIKBWxhYmVsGAMgASgJSACIAQFCCAoGX2xhYmVsIlUKIUNyZWF0ZUxlYWRSZWZlcnJhbFBhcnRuZXJSZXNwb25zZRIwCgdwYXJ0bmVyGAEgASgLMh8uY29ydGFkby52MS5MZWFkUmVmZXJyYWxQYXJ0bmVyIk8KIERlbGV0ZUxlYWRSZWZlcnJhbFBhcnRuZXJSZXF1ZXN0EhcKD29yZ2FuaXphdGlvbl9pZBgBIAEoCRISCgpwYXJ0bmVyX2lkGAIgASgJIiMKIURlbGV0ZUxlYWRSZWZlcnJhbFBhcnRuZXJSZXNwb25zZSKVAQoXU2VuZExlYWRSZWZlcnJhbFJlcXVlc3QSFwoPb3JnYW5pemF0aW9uX2lkGAEgASgJEhIKCmlucXVpcnlfaWQYAiABKAkSDgoEY29kZRgDIAEoCUgAEhQKCnBhcnRuZXJfaWQYBCABKAlIABIRCgRub3RlGAUgASgJSAGIAQFCCwoJcmVjaXBpZW50QgcKBV9ub3RlIkYKGFNlbmRMZWFkUmVmZXJyYWxSZXNwb25zZRIqCghyZWZlcnJhbBgBIAEoCzIYLmNvcnRhZG8udjEuTGVhZFJlZmVycmFsIlsKGExpc3RMZWFkUmVmZXJyYWxzUmVxdWVzdBIXCg9vcmdhbml6YXRpb25faWQYASABKAkSFwoKaW5xdWlyeV9pZBgCIAEoCUgAiAEBQg0KC19pbnF1aXJ5X2lkIkgKGUxpc3RMZWFkUmVmZXJyYWxzUmVzcG9uc2USKwoJcmVmZXJyYWxzGAEgAygLMhguY29ydGFkby52MS5MZWFkUmVmZXJyYWwiOwogTGlzdEluY29taW5nTGVhZFJlZmVycmFsc1JlcXVlc3QSFwoPb3JnYW5pemF0aW9uX2lkGAEgASgJIlgKIUxpc3RJbmNvbWluZ0xlYWRSZWZlcnJhbHNSZXNwb25zZRIzCglyZWZlcnJhbHMYASADKAsyIC5jb3J0YWRvLnYxLkluY29taW5nTGVhZFJlZmVycmFsIkkKGUFjY2VwdExlYWRSZWZlcnJhbFJlcXVlc3QSFwoPb3JnYW5pemF0aW9uX2lkGAEgASgJEhMKC3JlZmVycmFsX2lkGAIgASgJIjAKGkFjY2VwdExlYWRSZWZlcnJhbFJlc3BvbnNlEhIKCmlucXVpcnlfaWQYASABKAkiSQoZUmVqZWN0TGVhZFJlZmVycmFsUmVxdWVzdBIXCg9vcmdhbml6YXRpb25faWQYASABKAkSEwoLcmVmZXJyYWxfaWQYAiABKAkiHAoaUmVqZWN0TGVhZFJlZmVycmFsUmVzcG9uc2UiSwobV2l0aGRyYXdMZWFkUmVmZXJyYWxSZXF1ZXN0EhcKD29yZ2FuaXphdGlvbl9pZBgBIAEoCRITCgtyZWZlcnJhbF9pZBgCIAEoCSIeChxXaXRoZHJhd0xlYWRSZWZlcnJhbFJlc3BvbnNlKuwBChZMZWFkUmVmZXJyYWxTdGF0dXNFbnVtEiQKIExFQURfUkVGRVJSQUxfU1RBVFVTX1VOU1BFQ0lGSUVEEAASIAocTEVBRF9SRUZFUlJBTF9TVEFUVVNfUEVORElORxABEiEKHUxFQURfUkVGRVJSQUxfU1RBVFVTX0FDQ0VQVEVEEAISIQodTEVBRF9SRUZFUlJBTF9TVEFUVVNfUkVKRUNURUQQAxIiCh5MRUFEX1JFRkVSUkFMX1NUQVRVU19XSVRIRFJBV04QBBIgChxMRUFEX1JFRkVSUkFMX1NUQVRVU19FWFBJUkVEEAVCJlokaHViLWJhY2tlbmQvZ2VuL2NvcnRhZG8vdjE7Y29ydGFkb3YxYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * LeadReferralSettings is the organization's opt-in and its code.
 *
 * @generated from message cortado.v1.LeadReferralSettings
 */
export type LeadReferralSettings = Message<"cortado.v1.LeadReferralSettings"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Whether other organizations can send leads to this one.
   *
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;

  /**
   * The code to hand out, formatted for display (e.g. "K7Q-4XM"). Empty
   * until the organization first turns referrals on.
   *
   * @generated from field: string code = 3;
   */
  code: string;
};

/**
 * Describes the message cortado.v1.LeadReferralSettings.
 * Use `create(LeadReferralSettingsSchema)` to create a new message.
 */
export const LeadReferralSettingsSchema: GenMessage<LeadReferralSettings> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 0);

/**
 * LeadReferralPartner is a code the organization saved.
 *
 * @generated from message cortado.v1.LeadReferralPartner
 */
export type LeadReferralPartner = Message<"cortado.v1.LeadReferralPartner"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * The name the sender gave the partner.
   *
   * @generated from field: string label = 20;
   */
  label: string;

  /**
   * The partner organization's current name.
   *
   * @generated from field: string partner_organization_name = 21;
   */
  partnerOrganizationName: string;

  /**
   * False when the partner turned referrals off or made a new code; the
   * sender needs the new code to send to it again.
   *
   * @generated from field: bool reachable = 50;
   */
  reachable: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.LeadReferralPartner.
 * Use `create(LeadReferralPartnerSchema)` to create a new message.
 */
export const LeadReferralPartnerSchema: GenMessage<LeadReferralPartner> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 1);

/**
 * LeadReferral is a sent referral, as the sending organization sees it.
 *
 * @generated from message cortado.v1.LeadReferral
 */
export type LeadReferral = Message<"cortado.v1.LeadReferral"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string inquiry_id = 10;
   */
  inquiryId: string;

  /**
   * @generated from field: string recipient_organization_name = 20;
   */
  recipientOrganizationName: string;

  /**
   * @generated from field: optional string note = 21;
   */
  note?: string;

  /**
   * @generated from field: cortado.v1.LeadReferralStatusEnum status = 50;
   */
  status: LeadReferralStatusEnum;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 51;
   */
  expiresAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp responded_at = 52;
   */
  respondedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 61;
   */
  createdBy: string;
};

/**
 * Describes the message cortado.v1.LeadReferral.
 * Use `create(LeadReferralSchema)` to create a new message.
 */
export const LeadReferralSchema: GenMessage<LeadReferral> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 2);

/**
 * IncomingLeadReferral is a pending referral as the receiving organization
 * sees it before accepting: no contact details or location.
 *
 * @generated from message cortado.v1.IncomingLeadReferral
 */
export type IncomingLeadReferral = Message<"cortado.v1.IncomingLeadReferral"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string sender_organization_name = 20;
   */
  senderOrganizationName: string;

  /**
   * The sender's event type name.
   *
   * @generated from field: optional string event_type_label = 21;
   */
  eventTypeLabel?: string;

  /**
   * Start of the first dated event, and its IANA timezone.
   *
   * @generated from field: optional google.protobuf.Timestamp first_event_date = 22;
   */
  firstEventDate?: Timestamp;

  /**
   * @generated from field: optional string first_event_timezone = 23;
   */
  firstEventTimezone?: string;

  /**
   * Guests across the lead's events.
   *
   * @generated from field: int32 total_guest_count = 24;
   */
  totalGuestCount: number;

  /**
   * Number of event days.
   *
   * @generated from field: int32 events_count = 25;
   */
  eventsCount: number;

  /**
   * @generated from field: optional string note = 26;
   */
  note?: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 51;
   */
  expiresAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.IncomingLeadReferral.
 * Use `create(IncomingLeadReferralSchema)` to create a new message.
 */
export const IncomingLeadReferralSchema: GenMessage<IncomingLeadReferral> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 3);

/**
 * @generated from message cortado.v1.GetLeadReferralSettingsRequest
 */
export type GetLeadReferralSettingsRequest = Message<"cortado.v1.GetLeadReferralSettingsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.GetLeadReferralSettingsRequest.
 * Use `create(GetLeadReferralSettingsRequestSchema)` to create a new message.
 */
export const GetLeadReferralSettingsRequestSchema: GenMessage<GetLeadReferralSettingsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 4);

/**
 * @generated from message cortado.v1.GetLeadReferralSettingsResponse
 */
export type GetLeadReferralSettingsResponse = Message<"cortado.v1.GetLeadReferralSettingsResponse"> & {
  /**
   * @generated from field: cortado.v1.LeadReferralSettings settings = 1;
   */
  settings?: LeadReferralSettings;
};

/**
 * Describes the message cortado.v1.GetLeadReferralSettingsResponse.
 * Use `create(GetLeadReferralSettingsResponseSchema)` to create a new message.
 */
export const GetLeadReferralSettingsResponseSchema: GenMessage<GetLeadReferralSettingsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 5);

/**
 * UpdateLeadReferralSettingsRequest turns referrals on or off. The first time
 * they are turned on the organization gets a code.
 *
 * @generated from message cortado.v1.UpdateLeadReferralSettingsRequest
 */
export type UpdateLeadReferralSettingsRequest = Message<"cortado.v1.UpdateLeadReferralSettingsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;
};

/**
 * Describes the message cortado.v1.UpdateLeadReferralSettingsRequest.
 * Use `create(UpdateLeadReferralSettingsRequestSchema)` to create a new message.
 */
export const UpdateLeadReferralSettingsRequestSchema: GenMessage<UpdateLeadReferralSettingsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 6);

/**
 * @generated from message cortado.v1.UpdateLeadReferralSettingsResponse
 */
export type UpdateLeadReferralSettingsResponse = Message<"cortado.v1.UpdateLeadReferralSettingsResponse"> & {
  /**
   * @generated from field: cortado.v1.LeadReferralSettings settings = 1;
   */
  settings?: LeadReferralSettings;
};

/**
 * Describes the message cortado.v1.UpdateLeadReferralSettingsResponse.
 * Use `create(UpdateLeadReferralSettingsResponseSchema)` to create a new message.
 */
export const UpdateLeadReferralSettingsResponseSchema: GenMessage<UpdateLeadReferralSettingsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 7);

/**
 * RegenerateLeadReferralCodeRequest replaces the code; the old one stops
 * working, including for partners who saved it.
 *
 * @generated from message cortado.v1.RegenerateLeadReferralCodeRequest
 */
export type RegenerateLeadReferralCodeRequest = Message<"cortado.v1.RegenerateLeadReferralCodeRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.RegenerateLeadReferralCodeRequest.
 * Use `create(RegenerateLeadReferralCodeRequestSchema)` to create a new message.
 */
export const RegenerateLeadReferralCodeRequestSchema: GenMessage<RegenerateLeadReferralCodeRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 8);

/**
 * @generated from message cortado.v1.RegenerateLeadReferralCodeResponse
 */
export type RegenerateLeadReferralCodeResponse = Message<"cortado.v1.RegenerateLeadReferralCodeResponse"> & {
  /**
   * @generated from field: cortado.v1.LeadReferralSettings settings = 1;
   */
  settings?: LeadReferralSettings;
};

/**
 * Describes the message cortado.v1.RegenerateLeadReferralCodeResponse.
 * Use `create(RegenerateLeadReferralCodeResponseSchema)` to create a new message.
 */
export const RegenerateLeadReferralCodeResponseSchema: GenMessage<RegenerateLeadReferralCodeResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 9);

/**
 * LookupLeadReferralCodeRequest checks a code before sending. A failed lookup
 * counts toward the organization's hourly limit.
 *
 * @generated from message cortado.v1.LookupLeadReferralCodeRequest
 */
export type LookupLeadReferralCodeRequest = Message<"cortado.v1.LookupLeadReferralCodeRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;
};

/**
 * Describes the message cortado.v1.LookupLeadReferralCodeRequest.
 * Use `create(LookupLeadReferralCodeRequestSchema)` to create a new message.
 */
export const LookupLeadReferralCodeRequestSchema: GenMessage<LookupLeadReferralCodeRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 10);

/**
 * @generated from message cortado.v1.LookupLeadReferralCodeResponse
 */
export type LookupLeadReferralCodeResponse = Message<"cortado.v1.LookupLeadReferralCodeResponse"> & {
  /**
   * @generated from field: string organization_name = 1;
   */
  organizationName: string;
};

/**
 * Describes the message cortado.v1.LookupLeadReferralCodeResponse.
 * Use `create(LookupLeadReferralCodeResponseSchema)` to create a new message.
 */
export const LookupLeadReferralCodeResponseSchema: GenMessage<LookupLeadReferralCodeResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 11);

/**
 * @generated from message cortado.v1.ListLeadReferralPartnersRequest
 */
export type ListLeadReferralPartnersRequest = Message<"cortado.v1.ListLeadReferralPartnersRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListLeadReferralPartnersRequest.
 * Use `create(ListLeadReferralPartnersRequestSchema)` to create a new message.
 */
export const ListLeadReferralPartnersRequestSchema: GenMessage<ListLeadReferralPartnersRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 12);

/**
 * @generated from message cortado.v1.ListLeadReferralPartnersResponse
 */
export type ListLeadReferralPartnersResponse = Message<"cortado.v1.ListLeadReferralPartnersResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.LeadReferralPartner partners = 1;
   */
  partners: LeadReferralPartner[];
};

/**
 * Describes the message cortado.v1.ListLeadReferralPartnersResponse.
 * Use `create(ListLeadReferralPartnersResponseSchema)` to create a new message.
 */
export const ListLeadReferralPartnersResponseSchema: GenMessage<ListLeadReferralPartnersResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 13);

/**
 * CreateLeadReferralPartnerRequest saves a code. Saving a code for an
 * organization already saved replaces its code and label.
 *
 * @generated from message cortado.v1.CreateLeadReferralPartnerRequest
 */
export type CreateLeadReferralPartnerRequest = Message<"cortado.v1.CreateLeadReferralPartnerRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * Defaults to the partner organization's name.
   *
   * @generated from field: optional string label = 3;
   */
  label?: string;
};

/**
 * Describes the message cortado.v1.CreateLeadReferralPartnerRequest.
 * Use `create(CreateLeadReferralPartnerRequestSchema)` to create a new message.
 */
export const CreateLeadReferralPartnerRequestSchema: GenMessage<CreateLeadReferralPartnerRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 14);

/**
 * @generated from message cortado.v1.CreateLeadReferralPartnerResponse
 */
export type CreateLeadReferralPartnerResponse = Message<"cortado.v1.CreateLeadReferralPartnerResponse"> & {
  /**
   * @generated from field: cortado.v1.LeadReferralPartner partner = 1;
   */
  partner?: LeadReferralPartner;
};

/**
 * Describes the message cortado.v1.CreateLeadReferralPartnerResponse.
 * Use `create(CreateLeadReferralPartnerResponseSchema)` to create a new message.
 */
export const CreateLeadReferralPartnerResponseSchema: GenMessage<CreateLeadReferralPartnerResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 15);

/**
 * @generated from message cortado.v1.DeleteLeadReferralPartnerRequest
 */
export type DeleteLeadReferralPartnerRequest = Message<"cortado.v1.DeleteLeadReferralPartnerRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string partner_id = 2;
   */
  partnerId: string;
};

/**
 * Describes the message cortado.v1.DeleteLeadReferralPartnerRequest.
 * Use `create(DeleteLeadReferralPartnerRequestSchema)` to create a new message.
 */
export const DeleteLeadReferralPartnerRequestSchema: GenMessage<DeleteLeadReferralPartnerRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 16);

/**
 * @generated from message cortado.v1.DeleteLeadReferralPartnerResponse
 */
export type DeleteLeadReferralPartnerResponse = Message<"cortado.v1.DeleteLeadReferralPartnerResponse"> & {
};

/**
 * Describes the message cortado.v1.DeleteLeadReferralPartnerResponse.
 * Use `create(DeleteLeadReferralPartnerResponseSchema)` to create a new message.
 */
export const DeleteLeadReferralPartnerResponseSchema: GenMessage<DeleteLeadReferralPartnerResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 17);

/**
 * SendLeadReferralRequest refers one of the organization's leads to the
 * organization holding the code, or to a saved partner.
 *
 * @generated from message cortado.v1.SendLeadReferralRequest
 */
export type SendLeadReferralRequest = Message<"cortado.v1.SendLeadReferralRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string inquiry_id = 2;
   */
  inquiryId: string;

  /**
   * @generated from oneof cortado.v1.SendLeadReferralRequest.recipient
   */
  recipient: {
    /**
     * @generated from field: string code = 3;
     */
    value: string;
    case: "code";
  } | {
    /**
     * @generated from field: string partner_id = 4;
     */
    value: string;
    case: "partnerId";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: optional string note = 5;
   */
  note?: string;
};

/**
 * Describes the message cortado.v1.SendLeadReferralRequest.
 * Use `create(SendLeadReferralRequestSchema)` to create a new message.
 */
export const SendLeadReferralRequestSchema: GenMessage<SendLeadReferralRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 18);

/**
 * @generated from message cortado.v1.SendLeadReferralResponse
 */
export type SendLeadReferralResponse = Message<"cortado.v1.SendLeadReferralResponse"> & {
  /**
   * @generated from field: cortado.v1.LeadReferral referral = 1;
   */
  referral?: LeadReferral;
};

/**
 * Describes the message cortado.v1.SendLeadReferralResponse.
 * Use `create(SendLeadReferralResponseSchema)` to create a new message.
 */
export const SendLeadReferralResponseSchema: GenMessage<SendLeadReferralResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 19);

/**
 * ListLeadReferralsRequest lists the organization's sent referrals, newest
 * first, optionally for one lead.
 *
 * @generated from message cortado.v1.ListLeadReferralsRequest
 */
export type ListLeadReferralsRequest = Message<"cortado.v1.ListLeadReferralsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: optional string inquiry_id = 2;
   */
  inquiryId?: string;
};

/**
 * Describes the message cortado.v1.ListLeadReferralsRequest.
 * Use `create(ListLeadReferralsRequestSchema)` to create a new message.
 */
export const ListLeadReferralsRequestSchema: GenMessage<ListLeadReferralsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 20);

/**
 * @generated from message cortado.v1.ListLeadReferralsResponse
 */
export type ListLeadReferralsResponse = Message<"cortado.v1.ListLeadReferralsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.LeadReferral referrals = 1;
   */
  referrals: LeadReferral[];
};

/**
 * Describes the message cortado.v1.ListLeadReferralsResponse.
 * Use `create(ListLeadReferralsResponseSchema)` to create a new message.
 */
export const ListLeadReferralsResponseSchema: GenMessage<ListLeadReferralsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 21);

/**
 * ListIncomingLeadReferralsRequest lists the referrals waiting on the
 * organization, soonest deadline first.
 *
 * @generated from message cortado.v1.ListIncomingLeadReferralsRequest
 */
export type ListIncomingLeadReferralsRequest = Message<"cortado.v1.ListIncomingLeadReferralsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListIncomingLeadReferralsRequest.
 * Use `create(ListIncomingLeadReferralsRequestSchema)` to create a new message.
 */
export const ListIncomingLeadReferralsRequestSchema: GenMessage<ListIncomingLeadReferralsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 22);

/**
 * @generated from message cortado.v1.ListIncomingLeadReferralsResponse
 */
export type ListIncomingLeadReferralsResponse = Message<"cortado.v1.ListIncomingLeadReferralsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.IncomingLeadReferral referrals = 1;
   */
  referrals: IncomingLeadReferral[];
};

/**
 * Describes the message cortado.v1.ListIncomingLeadReferralsResponse.
 * Use `create(ListIncomingLeadReferralsResponseSchema)` to create a new message.
 */
export const ListIncomingLeadReferralsResponseSchema: GenMessage<ListIncomingLeadReferralsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 23);

/**
 * AcceptLeadReferralRequest creates the lead in the receiving organization,
 * assigned to the caller.
 *
 * @generated from message cortado.v1.AcceptLeadReferralRequest
 */
export type AcceptLeadReferralRequest = Message<"cortado.v1.AcceptLeadReferralRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string referral_id = 2;
   */
  referralId: string;
};

/**
 * Describes the message cortado.v1.AcceptLeadReferralRequest.
 * Use `create(AcceptLeadReferralRequestSchema)` to create a new message.
 */
export const AcceptLeadReferralRequestSchema: GenMessage<AcceptLeadReferralRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 24);

/**
 * @generated from message cortado.v1.AcceptLeadReferralResponse
 */
export type AcceptLeadReferralResponse = Message<"cortado.v1.AcceptLeadReferralResponse"> & {
  /**
   * The new lead in the receiving organization.
   *
   * @generated from field: string inquiry_id = 1;
   */
  inquiryId: string;
};

/**
 * Describes the message cortado.v1.AcceptLeadReferralResponse.
 * Use `create(AcceptLeadReferralResponseSchema)` to create a new message.
 */
export const AcceptLeadReferralResponseSchema: GenMessage<AcceptLeadReferralResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 25);

/**
 * @generated from message cortado.v1.RejectLeadReferralRequest
 */
export type RejectLeadReferralRequest = Message<"cortado.v1.RejectLeadReferralRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string referral_id = 2;
   */
  referralId: string;
};

/**
 * Describes the message cortado.v1.RejectLeadReferralRequest.
 * Use `create(RejectLeadReferralRequestSchema)` to create a new message.
 */
export const RejectLeadReferralRequestSchema: GenMessage<RejectLeadReferralRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 26);

/**
 * @generated from message cortado.v1.RejectLeadReferralResponse
 */
export type RejectLeadReferralResponse = Message<"cortado.v1.RejectLeadReferralResponse"> & {
};

/**
 * Describes the message cortado.v1.RejectLeadReferralResponse.
 * Use `create(RejectLeadReferralResponseSchema)` to create a new message.
 */
export const RejectLeadReferralResponseSchema: GenMessage<RejectLeadReferralResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 27);

/**
 * WithdrawLeadReferralRequest takes back a pending referral the
 * organization sent.
 *
 * @generated from message cortado.v1.WithdrawLeadReferralRequest
 */
export type WithdrawLeadReferralRequest = Message<"cortado.v1.WithdrawLeadReferralRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string referral_id = 2;
   */
  referralId: string;
};

/**
 * Describes the message cortado.v1.WithdrawLeadReferralRequest.
 * Use `create(WithdrawLeadReferralRequestSchema)` to create a new message.
 */
export const WithdrawLeadReferralRequestSchema: GenMessage<WithdrawLeadReferralRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 28);

/**
 * @generated from message cortado.v1.WithdrawLeadReferralResponse
 */
export type WithdrawLeadReferralResponse = Message<"cortado.v1.WithdrawLeadReferralResponse"> & {
};

/**
 * Describes the message cortado.v1.WithdrawLeadReferralResponse.
 * Use `create(WithdrawLeadReferralResponseSchema)` to create a new message.
 */
export const WithdrawLeadReferralResponseSchema: GenMessage<WithdrawLeadReferralResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_referrals, 29);

/**
 * LeadReferralStatusEnum is where a referral stands. A pending referral past
 * its deadline reads as EXPIRED.
 *
 * @generated from enum cortado.v1.LeadReferralStatusEnum
 */
export enum LeadReferralStatusEnum {
  /**
   * @generated from enum value: LEAD_REFERRAL_STATUS_UNSPECIFIED = 0;
   */
  LEAD_REFERRAL_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: LEAD_REFERRAL_STATUS_PENDING = 1;
   */
  LEAD_REFERRAL_STATUS_PENDING = 1,

  /**
   * @generated from enum value: LEAD_REFERRAL_STATUS_ACCEPTED = 2;
   */
  LEAD_REFERRAL_STATUS_ACCEPTED = 2,

  /**
   * @generated from enum value: LEAD_REFERRAL_STATUS_REJECTED = 3;
   */
  LEAD_REFERRAL_STATUS_REJECTED = 3,

  /**
   * @generated from enum value: LEAD_REFERRAL_STATUS_WITHDRAWN = 4;
   */
  LEAD_REFERRAL_STATUS_WITHDRAWN = 4,

  /**
   * @generated from enum value: LEAD_REFERRAL_STATUS_EXPIRED = 5;
   */
  LEAD_REFERRAL_STATUS_EXPIRED = 5,
}

/**
 * Describes the enum cortado.v1.LeadReferralStatusEnum.
 */
export const LeadReferralStatusEnumSchema: GenEnum<LeadReferralStatusEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_referrals, 0);

